import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import {
  getStationRouteStationDurationDetails,
  IStationRouteDto,
  SECONDS_IN_MINUTE,
  useTimezone,
} from "@ryde/shared";

import { FramerTooltip } from "../framer-tooltip";
import { StationDurationTooltipContentStyled } from "./station-duration-tooltip.styled";

interface IStationRouteDurationTooltip {
  stationRouteDto: Partial<IStationRouteDto> | undefined;
  stationIndex: number;
  children: ReactNode;
}

export const StationRouteDurationTooltip: FC<IStationRouteDurationTooltip> = ({
  stationRouteDto,
  stationIndex,
  children,
}) => {
  const { t } = useTranslation();
  const { timezone } = useTimezone();

  const durationDetails = getStationRouteStationDurationDetails({
    stationRouteDto,
    index: stationIndex,
    timezone,
  });

  if (
    !durationDetails.previousStationTime ||
    !durationDetails.nextStationTime
  ) {
    return <>{children}</>;
  }

  const tooltipContent = (
    <StationDurationTooltipContentStyled>
      <div>
        <strong>{t("ride.PREVIOUS_STATION_TIME")}:</strong>{" "}
        {durationDetails.previousStationTime}
      </div>
      {!!durationDetails.durationSeconds && (
        <div>
          <strong>{t("ride.DURATION_TO_NEXT_STATION")}:</strong>{" "}
          {durationDetails.durationSeconds}s = {durationDetails.durationMinutes}
          m{durationDetails.durationSeconds % SECONDS_IN_MINUTE}s
        </div>
      )}
      <div>
        <strong>{t("ride.NEXT_STATION_TIME")}:</strong>{" "}
        {durationDetails.nextStationTime}
      </div>
    </StationDurationTooltipContentStyled>
  );

  return (
    <FramerTooltip content={tooltipContent}>
      <>{children}</>
    </FramerTooltip>
  );
};
